
import './input.css';
import PropTypes from "prop-types";
import {buttonCommon, blueButton, outlineButton} from "./classNames"
import { generateRandomString } from 'helpers/helper';
import { Fragment, useMemo } from 'react';

const getRandomId = (propId) => {
  return propId ? propId :generateRandomString(15);
}

export const InputText = (props) => {
  const {value,name,className, type, onChange, placeholder,error,info, onBlur, onFocus, label, autoFocus} 
    = {type:'text',autoFocus:false,...props};
  let stateClassName='';
  let msg;
  const id = useMemo(() => getRandomId(props.id),[props.id]);

  if(info) {
    stateClassName='info';
    msg=info;
  }

  if(error) {
    stateClassName='error';
    msg=error;
  } 
  const inputClasses = `w-full rounded border-0 px-1 pt-2 pb-2 leading-3 text-uhnavy`;
  return(
    <Fragment>
      {
        label && <label for={id} className='w-full inline-block font-bold font-xl '>{label}</label>
      }
      <div className={`inputWrapper border border-uhblue rounded ${stateClassName} ${className}`}>
        
        <input 
          type={type} 
          id={id}
          value={value} 
          name={name}
          onChange={e=>onChange(e.target.value)}
          placeholder={placeholder}
          onBlur={onBlur}
          onFocus={onFocus}
          className={inputClasses}
          autoFocus={autoFocus}
        />
        <div className={`inputMsg ${stateClassName}`}>
          {msg}
        </div>
      </div>
    </Fragment>
    
  );
}

export const InputReset = (props) => {
  const {value, onClick, className, outline} = {outline:true, ...props};
  let appliedClass = 'blueButton';
  if(outline) {
    appliedClass = `outlineBlueButton`
  }
  return (
    <div  className={`inline-block ${className}`}>
      <input
        type={'Reset'}
        value={value}
        onClick={onClick}
        onChange={()=>{}}
        className={`${buttonCommon} ${outlineButton}  ${appliedClass}`}
      />
    </div>

  );
}

export const InputRadio = (props) => {
  const {name, onChange, className, checked, value, label} = {...props};
  const id = useMemo(() => getRandomId(props.id),[props.id]);
  return (
    <div className={className}>
      <div className='flex flex-row'>
        {
          label && <label className='inline-block ml-2 font-xl' for={id}>{label}</label>
        }
        <input
          type={'radio'}
          name={name}
          value={value}
          checked={checked}
          onChange={e=>onChange(e.target.value)}
          className={`order-first`}
          id={id}
        />
      
      </div>
    </div>

  );
}   

export const InputSubmit = (props) => {
  const {text, onClick, className, outline, loading, disabled} = {outline:false, ...props};
  let appliedClass = 'blueButton';
  if(outline) {
    appliedClass = `outlineBlueButton`
  }
  let loadingClass,disabledClass ="";
  if(loading) {
    loadingClass = 'loading ';
  }
  if(disabled) {
    disabledClass = 'disabled'
  }

  const handleChange = (e) => {
    if(disabled || loading) {
      return false;
    }
    onClick(e);
  }
  return (
    <div className={`inline-block ${className} blueButtonContainer`}>
      <input
        type={'submit'}
        value={text}
        onClick={handleChange}
        onChange={()=>{}}
        className={`${buttonCommon} ${blueButton} ${appliedClass} ${loadingClass} ${disabledClass}`}
      />
    </div>

  );
}

InputText.propTypes = {
  value: PropTypes.any.isRequired,
  onChange: PropTypes.func.isRequired
}

InputText.InputReset = {
  value: PropTypes.any.isRequired,
}

InputText.InputSubmit = {
  value: PropTypes.any.isRequired,
}